import { defineComponent as _defineComponent } from 'vue'
import { ExportListType } from 'ah-api-gateways/models/rest/download';
import { BModal } from 'bootstrap-vue';
import { BFormSelect } from 'bootstrap-vue';
import { reactive, ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ListDownloadButton',
  props: {
  downloadOptions: {
    type: Array<{ value: string; text: string }>,
    required: false,
    default: () => [
      { value: 'PDF', text: 'PDF' },
      { value: 'XLSX', text: 'Excel' },
      { value: 'CSV', text: 'CSV' },
    ],
  },
  loading: {
    type: [Boolean, String],
    default: false,
  },
  disabled: {
    type: [Boolean, String],
    default: false,
  },
  allowExportWithDetails: {
    type: [Boolean, String],
    default: false,
  },
  buttonClass: {
    type: String,
    default: 'btn-primary short',
  },
},
  emits: ["download"],
  setup(__props, { emit }: { emit: ({
  (e: 'download', exportType: ExportListType, options: { withDetails: boolean }): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props;

const listDownloadButtonWithDetailsModal = ref<InstanceType<typeof BModal> | null>(null);





const state = reactive<{
  selectedFormat: ExportListType;
}>({
  selectedFormat: ExportListType.XLSX,
});

function showModal() {
  listDownloadButtonWithDetailsModal.value?.show();
}

function hideModal() {
  listDownloadButtonWithDetailsModal.value?.hide();
}

function triggerExport(format: ExportListType, withDetails: boolean) {
  emit('download', format, { withDetails });
  hideModal();
}

function exportData() {
  if (props.allowExportWithDetails) {
    showModal();
    return;
  }
  triggerExport(state.selectedFormat, false);
}

return { __sfc: true,listDownloadButtonWithDetailsModal, emit, props, state, showModal, hideModal, triggerExport, exportData, BModal, BFormSelect }
}

})